import Auth from '../../Auth'

import ClientProfile from './Profile'

export default class ClientRegistration extends ClientProfile
{
    static path = '/client/org/registration';

    /**
     * The title shown on the form
     */
	formTitle()
	{
		if (!this.canRegisterClientOrg()) {
			return TB.tryTrans('clients.register_company.title_unauthorized');
		}

		return TB.tryTrans('clients.register_company.title');
	}

    /**
     * The subtitle shown on the form
     */
    formSubtitle()
    {
		if (!this.canRegisterClientOrg()) {
			return TB.tryTrans('clients.register_company.subtitle_unauthorized');
		}

		return super.formSubtitle();
    }

    /**
     * The submit button options for the form
     */
    formSubmit()
    {
		if (!this.canRegisterClientOrg()) {
			return false;
		}

		return super.formSubmit();
    }

	/**
     * The fields mapping for the form
     */
	formFields()
	{
		if (!this.canRegisterClientOrg()) {
			return {};
		}

		return super.formFields();
	}

    /**
     * The links mapping for the form
     */
    formLinks()
    {
		if (!this.canRegisterClientOrg()) {
			return [];
		}

		return super.formLinks();
    }

    /**
     * @returns {Boolean}
     */
    canRegisterClientOrg()
    {
        let user = Auth.user();
        if (!user) {
        	return;
        }

        if (user.isClientConsultant() || user.isClientManager() || user.isPlatformUser()) {
        	return true;
        }

		return user.isClient()
			&& user.hasClientOrg()
			&& user.isClientAdmin();
    }
}